import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PairingRequestComponent } from '../pairing-request/pairing-request.component';

@Component({
  selector: 'era-pairing-request-modal',
  templateUrl: './pairing-request-modal.container.html',
  styleUrls: ['./pairing-request-modal.container.scss'],
  imports: [PairingRequestComponent],
})
export class PairingRequestModalComponent {
  constructor(public readonly activeModal: NgbActiveModal) {}
}
